<template>
  <div class="row mt-5 align-items-center">
    <div class="col-auto mr-4">
      <h4>Saldo dos serviços extras</h4>
    </div>
   <div class="col-auto text-left">
      <router-link :to="{ name: 'mercado' }" class="btn btn-customizado btn-customizado-azul ml-2">
                Adquirir Serviços

      </router-link>
    </div>
    <div class="col-12 mt-4">
      <table class="table table-custom" >
        <thead class="thead" style="background: #9e9e9e12">
          <tr>
            <th class="p-3 border-0">Descrição</th>
            <th class="p-3 text-center border-0">Adquirido</th>
            <th class="p-3 text-center border-0">Saldo</th>
            <th class="p-3 text-center border-0">Validade</th>
          </tr>
        </thead>
        <tbody>
        <template v-if="this.contratosAdicionaisCredito.length > 0">
            <tr v-for="(item, index) in this.contratosAdicionaisCredito" :key="index">
              <td>{{ item["produto_nome"] }} - {{ item["plano_nome"] }}</td>
              <td class="text-center">{{ item.quantidade_adquirida }}</td>
              <td class="text-center">{{ (item.quantidade_disponivel ) }}</td>
              <td class="text-center"> {{ item.data_validade_credito != null ? $date(item.data_validade_credito).format('DD/MM/YYYY') : '- - - - -' }}</td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="4" class="text-center">Não há serviços disponíveis.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {

  props: [
    'contratosAdicionaisCredito',
    'valorTotal',
    'modalVerificaCancelamento',
    'formatarValorMonetario',
    'resumoContrato'
  ],
  methods: {
    chamarFuncaoComParametros (value) {
      return this.formatarValorMonetario(value)
    }
  }
}
</script>
